<template>
    <hts-drawer
        v-model="cVisible"
        title="Danh sách cảnh báo">
        <alert-list />
    </hts-drawer>
</template>

<script lang="ts" setup>
import AlertList from './alert-list.vue'

const cVisible = ref(false)
const show = () => {
  cVisible.value = true
}
const hide = () => {
  cVisible.value = false
}

defineExpose({ show, hide })
</script>
